export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n;
  const { getOption } = useOptionsStore();

  const userLanguage = getOption<string>("user_language");
  if (userLanguage && i18n?.locale) {
    i18n.locale.value = userLanguage;
  }
});
